import { Link } from 'react-router-dom';
import { ArrowPathIcon, EyeIcon } from '@heroicons/react/24/outline';
import Card from '@/components/ui/Card';
import Button from '@/components/ui/Button';
import Badge from '@/components/ui/Badge';
import {
  TableContainer, Table, TableHead, TableBody, TableRow, TableHeaderCell, TableCell,
} from '@/components/ui/Table';

const mockDeliveries = [
  { id: 1, book_title: 'Le Petit Prince', platform: 'Apple Books', status: 'PUSHED', created_at: '2024-01-15T10:30:00Z' },
  { id: 2, book_title: 'Guide voyage', platform: 'Google Play', status: 'PENDING', created_at: '2024-01-15T09:00:00Z' },
  { id: 3, book_title: 'Manuel technique', platform: 'Apple Books', status: 'FAILED', error: 'Invalid metadata', created_at: '2024-01-14T16:00:00Z' },
  { id: 4, book_title: 'Recettes', platform: 'SFTP', status: 'PULLED_CONFIRMED', created_at: '2024-01-14T14:00:00Z' },
];

function getStatusBadge(status: string) {
  const variants: Record<string, 'success' | 'warning' | 'danger' | 'primary'> = {
    PUSHED: 'success', PULLED_CONFIRMED: 'success', PENDING: 'warning', FAILED: 'danger',
  };
  return <Badge variant={variants[status] || 'slate'}>{status}</Badge>;
}

export default function DistDeliveriesPage() {
  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h1 className="text-2xl font-bold text-slate-800">Deliveries</h1>
        <p className="text-slate-500 mt-1">Track book deliveries to platforms</p>
      </div>

      <Card padding="none">
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow isHoverable={false}>
                <TableHeaderCell>Book</TableHeaderCell>
                <TableHeaderCell>Platform</TableHeaderCell>
                <TableHeaderCell>Status</TableHeaderCell>
                <TableHeaderCell>Date</TableHeaderCell>
                <TableHeaderCell>Actions</TableHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {mockDeliveries.map((delivery) => (
                <TableRow key={delivery.id}>
                  <TableCell className="font-medium">{delivery.book_title}</TableCell>
                  <TableCell>{delivery.platform}</TableCell>
                  <TableCell>{getStatusBadge(delivery.status)}</TableCell>
                  <TableCell className="text-sm text-slate-500">
                    {new Date(delivery.created_at).toLocaleString()}
                  </TableCell>
                  <TableCell>
                    <div className="flex gap-2">
                      <Link to={`/distribution/deliveries/${delivery.id}`}>
                        <Button variant="ghost" size="sm" leftIcon={<EyeIcon className="w-3 h-3" />}>View</Button>
                      </Link>
                      {delivery.status === 'FAILED' && (
                        <Button variant="ghost" size="sm" leftIcon={<ArrowPathIcon className="w-3 h-3" />}>Retry</Button>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </div>
  );
}

